// src/components/circles/CircleVisibilityBadge.tsx

import type { CircleVisibility } from '../../types/api';
import { CIRCLE_VISIBILITY_CHIP, CIRCLE_VISIBILITY_LABELS } from './circleDisplay';

interface Props {
  visibility: CircleVisibility;
  className?: string;
}

export default function CircleVisibilityBadge({ visibility, className }: Props) {
  return (
    <span
      className={`text-xs font-medium px-2 py-0.5 rounded-full ${CIRCLE_VISIBILITY_CHIP[visibility]} ${className ?? ''}`}
      data-testid={`circle-visibility-badge-${visibility}`}
    >
      {CIRCLE_VISIBILITY_LABELS[visibility]}
    </span>
  );
}
